// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"3b2057c4","255":"13495cf8","499":"a0a7d2a7","673":"6ed53617","845":"22b506bd"}[chunkId] + ".css";
};